import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { PayoutsApiAdapter } from '../adapters';
import { PayoutFilters } from '../models';

interface UsePayoutsProps {
    filters: PayoutFilters;
    sorting?: { field: string; direction: 'asc' | 'desc' } | null;
    enabled?: boolean;
}

export const usePayouts = ({ filters, sorting, enabled = true }: UsePayoutsProps) => {
    const httpClient = createHttpClient(apiClientWH);
    const payoutsAdapter = new PayoutsApiAdapter(httpClient);

    const {
        data,
        isLoading,
        isFetching,
        error,
        refetch,
    } = useQuery({
        queryKey: ['cod-payouts', filters, sorting], // Incluir sorting explícitamente para asegurar que se dispare el fetch
        queryFn: () => payoutsAdapter.getPayouts(filters),
        enabled,
        staleTime: 2 * 60 * 1000, // 2 minutos
        gcTime: 5 * 60 * 1000, // 5 minutos
        placeholderData: (previousData) => previousData, // 🎯 Mantener datos previos visibles durante refetch
    });

    return {
        payouts: data?.data ?? [],
        meta: data?.meta,
        links: data?.links,
        isLoading,
        isFetching,
        error: error ? (error as Error).message : null,
        refetch,
    };
};

